import React, { Component } from 'react';
import { array, bool, number, object, oneOf, string } from 'prop-types';
import { connect } from 'react-redux';
import { getContext } from '@fiverr-private/fiverr_context';
import { MP_CLICKED_PACKAGE_SELECT } from '../../../utils/mixPanelEvents';
import { BQ_CLICKED_PACKAGE_SELECT } from '../../../utils/bigQueryEvents';
import { ORDER_NOW_BUTTON_CLICKS } from '../../../utils/sendGraphiteEvent/events';
import { CHECKOUT_PLANS } from '../../../utils/packagesUtils/constants';
import { sendGraphiteEvent } from '../../../utils/sendGraphiteEvent';
import { isFiverrChoice } from '../../../utils/fiverrChoice';
import { isRisingTalent } from '../../../utils/risingTalent';
import { getSelectedCheckoutPlan, getSelectedRecurringOption, isSinglePackage } from '../../../reducers/packages';
import FormGigItems from './FormGigItems';

class CheckoutFormHOC extends Component {

    constructor() {
        super();

        this.state = {
            inProgress: false
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    reportBI() {
        const { selectedPackageId, selectedRecurringOption, source } = this.props;
        const { biEvents } = this.context;

        const params = {
            id: selectedPackageId,
            source
        };

        if (this.isRecurringOrderPlan()) {
            params.selectedRecurringOption = selectedRecurringOption;
        }

        biEvents.sendMixPanelEvent({ eventName: MP_CLICKED_PACKAGE_SELECT, params });
        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_PACKAGE_SELECT, params });

        sendGraphiteEvent(ORDER_NOW_BUTTON_CLICKS);
    }

    onSubmit() {
        this.setState({ inProgress: true });
        this.reportBI();
    }

    isFiverrChoice() {
        const { choiceEligibilities } = this.context;
        const { queryParameters, abTests } = getContext();

        return isFiverrChoice({ queryParameters, abTests, choiceEligibilities });
    }

    isRisingTalent() {
        const { general } = this.context;
        const { isHandpicked } = general;

        return isRisingTalent(isHandpicked);
    }

    isRecurringOrderPlan() {
        const { selectedCheckoutPlan } = this.props;

        return selectedCheckoutPlan === CHECKOUT_PLANS.RECURRING_ORDER;
    }

    render() {
        const {
            selectedPackageId,
            selectedRecurringOption,
            children,
            isSingle,
            quantity,
            className
        } = this.props;

        const { pathfinderWrapper, general } = this.context;
        const { gigId } = general;
        const { csrfToken, isMobile } = getContext();
        const { inProgress } = this.state;
        const isFiverrChoice = this.isFiverrChoice();
        const isRisingTalent = !isFiverrChoice && this.isRisingTalent();
        const isRecurringOrderPlan = this.isRecurringOrderPlan();

        const formAction = isMobile ? 'checkout_package' : 'checkout_customize';

        return (
            <form className={className} action={`${pathfinderWrapper.pathfinder(formAction, { gig_id: gigId })}`}
                method="post" onSubmit={this.onSubmit}>
                <input type="hidden" name="authenticity_token" value={csrfToken}/>
                <input type="hidden" name="packages[gig_id]" value={gigId}/>
                <input type="hidden" name="packages[package_id]" value={selectedPackageId}/>
                <input type="hidden" name="fiverr_choice" value={isFiverrChoice}/>
                <input type="hidden" name="rising_talent" value={isRisingTalent}/>
                {isSingle &&
                <>
                    <input type="hidden" name="gig_id" value={gigId}/>
                    <input type="hidden" name="quantity" value={quantity}/>
                </>
                }
                {isRecurringOrderPlan &&
                <input type="hidden" name="packages[recurring_option_id]"
                    value={selectedRecurringOption.id}/>
                }
                <FormGigItems packageId={selectedPackageId}/>
                {
                    React.Children.map(children, (child) => {
                        if (child !== null) {
                            return React.cloneElement(child, { inProgress });
                        }
                    })
                }
            </form>
        );
    }
}

const mapStateToProps = ({ packages }, { selectedPackageId, source, className }) => ({
    selectedPackageId,
    selectedCheckoutPlan: getSelectedCheckoutPlan(packages),
    selectedRecurringOption: getSelectedRecurringOption(packages),
    source,
    className,
    isSingle: isSinglePackage(packages),
    quantity: packages.quantity
});

CheckoutFormHOC.propTypes = {
    selectedPackageId: number.isRequired,
    selectedCheckoutPlan: oneOf(Object.values(CHECKOUT_PLANS)),
    selectedRecurringOption: object,
    source: string.isRequired,
    isSingle: bool,
    quantity: number,
    className: string
};

CheckoutFormHOC.contextTypes = {
    biEvents: object,
    pathfinderWrapper: object,
    general: object,
    choiceEligibilities: array
};

export { CheckoutFormHOC };

export default connect(mapStateToProps)(CheckoutFormHOC);
